export const saveFeatureFlagData = data => ({
    type: 'SAVE_FEATURE_FLAG_DATA',
    data
});
